export default "__VITE_ASSET__DnGbj3hZ__"